<template>
    
    <div class="photo-gallery">
      <img
      v-for="(image, index) in images"
      :key="index"
      :src="image"
      :class="`photo photo-${index + 1}`"
      alt="Photo de la galerie"
    />    </div>
  
</template>

<script>
import { useHead } from '@vueuse/head';
    export default {
      name: 'HomeView',
        data() {
    return {
      images: [
        require('@/assets/Photos-accueil/Erminio.jpg'),
        require('@/assets/Photos-accueil/Iolanda_4.jpg'),
        require('@/assets/Photos-accueil/Paysage.jpg')
      ],
      
    };
  },
  setup() {
    useHead({
      title: 'Home Page',
      meta: [
        { name: 'description', content: 'Pablo Cirès - Bienvenue sur mon site .' },
        { name: 'keywords', content: 'home, réalisateur, documentaires, films' },
        { property: 'og:title', content: 'Home Page - Pablo Cirès' },
        { property: 'og:description', content: 'Bienvenue sur mon site.' },
        { property: 'og:url', content: 'https://www.pablocires.me/home' },
        { property: 'og:type', content: 'website' },
      ],
    });
  },
    }
</script>

<style scoped>

.photo-gallery {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 93.7vh;
} 

 .photo {
  width: 33.5%;  
  height: 100%;
  object-fit: cover;
}

.photo:nth-child(1) {
  object-position: bottom; 
  }

  .photo:nth-child(2) {
  object-position: bottom; 
  }

  .photo:nth-child(3) {
  object-position: left; 
  }

/* Mode responsive : images en pleine largeur */

 @media (max-width: 1200px) {
  .photo-gallery {
    flex-direction: column; 
    align-items:center; 
    height: 93.7vh; 
  }
  .photo {
    width: 100%; 
    height: 50%; 
    object-fit: cover;
  }

  .photo:nth-child(2) {
  object-position: right top; 
  }


}




</style>